import * as yup from 'yup';

export const formSchemaFn = (isActionEdit: boolean) =>
  yup.object().shape({
    code: isActionEdit
      ? yup.string()
      : yup
          .string()
          .trim()
          .required('コードは未入力です。')
          .max(255, 'コードは255文字以内で入力してください。'),
    labelJp: yup
      .string()
      .trim()
      .required('表示名は未入力です。')
      .max(255, '表示名は255文字以内で入力してください。'),
    prompt: yup.string().trim().required('プロンプトは未入力です。'),
    sortOrder: yup
      .number()
      .typeError('並び順は数字で入力してください。')
      .integer('並び順は整数で入力してください。')
      .min(0, '並び順は0以上で入力してください。')
      .required('並び順は未入力です。'),
    isActive: yup.boolean(),
  });
